import React, { useEffect, useState } from "react";
import "./BillingPlan.css";
var BillingPlan = function BillingPlan(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "billing-plan-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "billing-plan-root-content"
  }, "Please contact your admin !!!"));
};
export default BillingPlan;